import React, { useEffect } from 'react';
import './PrivacyPolicy.css';
import { useGeneralSetting } from '../../context/GeneralSettingContext';

const PrivacyPolicy = () => {
    const { generalSetting, loading } = useGeneralSetting();

    // Scroll to top when the component loads
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // The raw HTML content from your API
    const htmlContent = generalSetting?.privacy_policy || "";

    return (
        <div className="kfs-policy-master-wrapper">
            <div className="kfs-policy-glass-bg"></div>
            
            <div className="kfs-policy-container">
                {/* Modern Hero Header */}
                <header className="kfs-policy-hero">
                    <div className="kfs-hero-pattern"></div>
                    <div className="kfs-hero-content">
                        <span className="kfs-badge">Legal & Compliance</span>
                        <h1 className="kfs-title">Privacy & Security Policy</h1>
                        <p className="kfs-subtitle">
                            Krishna Finconcept Services (KFS) is committed to protecting your digital footprint with bank-grade security and transparency.
                        </p>
                        <div className="kfs-meta-info">
                            <div className="kfs-meta-item">
                                <span className="kfs-meta-label">Last Updated</span>
                                <span className="kfs-meta-value">March 2026</span>
                            </div>
                            <div className="kfs-meta-item">
                                <span className="kfs-meta-label">Document Version</span>
                                <span className="kfs-meta-value">v2.4 (Official)</span>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Main Content Area */}
                <main className="kfs-policy-body">
                    {loading ? (
                        <div className="kfs-loading-state">
                            <div className="kfs-loader"></div>
                            <p>Securely loading document...</p>
                        </div>
                    ) : (
                        <div 
                            className="kfs-formatted-content"
                            dangerouslySetInnerHTML={{ __html: htmlContent }}
                        />
                    )}
                </main>

                {/* Footer */}
                <footer className="kfs-policy-footer">
                    <div className="kfs-footer-content">
                        <p>&copy; {new Date().getFullYear()} {generalSetting?.site_name || 'Krishna Finconcept Services'}. All Rights Reserved.</p>
                        <p className="kfs-footer-sub">For queries, contact: <strong>{generalSetting?.email || 'info@loan-house.com'}</strong></p>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default PrivacyPolicy;